import { PackagingAidDto } from './packaging-aid-dto';
import { PackagingComponentEntryDto } from './packaging-component-entry-dto';

export class PackagingAidEntryDto extends PackagingComponentEntryDto {
  removedBeforeUsage: boolean | null = null;
  removedByConsumer: boolean | null = null;
  separationThroughCollectionAndSorting: boolean | null = null;
  underlyingComponent!: PackagingAidDto;
}
